<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">External system connection</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group" v-if="!newConnection">
                        <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportFiles()" title="Export">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Export</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        
                    <nav aria-label="breadcrumb" class="mu-mb-00">
                        <ol class="mcc-breadcrumb">
                            <li>Integrate</li>
                            <li>
                                <a class="table-link" @click="redirectToList()">External systems</a>
                            </li>
                            <li>
                                <router-link class="table-link" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{externalSystemName}}</router-link>
                            </li>
                            <li>
                                <a class="table-link" @click="redirectToFileAPI()">{{externalSystemAPIName}}</a>
                            </li>
                            <li v-if="newConnection" aria-current="page">Create new</li>
                            <li v-if="!newConnection" aria-current="page">{{connectionName}}</li>
                        </ol>
                    </nav>
               
                
                <div class="mcc-card ">
                    <div class="mcc-card__body">
                        <div class="mcc-row" v-show="fetchCall">
            <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-if="isReadOnly" >
                    <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                    <p>
                        <strong>Warning!</strong>
                        <br />{{readOnlyMsg}}
                        <br />
                    </p>
                </mcc-alert>

            </div>
            <div>
                <form novalidate id="connectionForm" @submit.prevent="saveFileConnection()">

                    <div style="position:relative">
                        <div v-show="!updateCall" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Active connection</h2>
                            </div>

                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label for="name" >Connection type</label>
                                            <input type="text" id="file" name="file" value="FILE" readonly>

                                        </div>
                                        <div class="mfc-slim-select-wrapper   mfc-form-input-wrapper--width">
                                            <label for="applicationId" class="mfc-label--required">File protocol</label>
                                            <select class="mfc-slim-select" :disabled=isReadOnly :value="dto.fileProtocol" @change="updateProtocolTytpe($event)" ref="protocolTypeRef" name="protocol-select" id="protocol-selectId" block>
                                                <option :selected="dto.fileProtocol === 'DIRECTORY'" value="DIRECTORY">Directory</option>
                                                <option :selected="dto.fileProtocol === 'FTP'" value="FTP">FTP</option>
                                                <option :selected="dto.fileProtocol === 'SFTP'" value="SFTP">SFTP</option>
                                            </select>
                                        </div>
                                        <div class="seperator mu-my-06"></div>
                                        <div v-if="dto.fileProtocol=='DIRECTORY'">
                                            <span class="mu-fw-semi-bold">Directory fields</span>
                                        </div>
                                        <div v-if="dto.fileProtocol!='DIRECTORY'">
                                            <span class="mu-fw-semi-bold">SFTP/FTP fields</span>
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label for="name" class="mfc-label--required">Name</label>
                                            <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :value="dto.name" :pattern="nameRegex" @change="updateName($event)">

                                        </div>

                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label for="host" class="mfc-label--required">Host</label>
                                            <input type="text" id="host" name="host" required="" placeholder="Host" maxlength="50" :disabled="isReadOnly" :value="dto.host" @change="updateHost($event)" ref="host" :pattern="helpDocumentationES">

                                        </div>

                                        <div class="mcc-row" v-if="dto.fileProtocol!='DIRECTORY'">
                                            <div class="mcc-col">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                                    <label for="filePath" class="mfc-label--required">File path</label>
                                                    <input type="text" id="filePath" name="filePath" required="" placeholder="File path" maxlength="50" :disabled="isReadOnly" style="margin-top: 0!important;" :value="dto.filePath" @change="updateFilePath($event)" ref="filePath" :pattern="filePathRegex">

                                                </div>
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width" id="port" ref="port">
                                                    <label for="portInput">Port</label>
                                                    <input type="number" name="port" min="1" max="65535" required="" placeholder="Port" id="portInput" :disabled="isReadOnly" :value="dto.port" @change="dto.port = $event.target.value">

                                                </div>

                                            </div>

                                        </div>
                                        <div class="mcc-row" v-if="dto.fileProtocol=='DIRECTORY'">
                                            <div class="mcc-col">
                                                <div>
                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                                        <label for="directory" class="mfc-label--required">Directory</label>
                                                        <input type="text" id="directory" name="directory" required="" placeholder="Directory" maxlength="50" :disabled="isReadOnly" style="margin-top: 0!important;" :value="dto.directory" @change="dto.directory = $event.target.value" ref="directory" :pattern="filePathRegex">

                                                    </div>
                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                                        <label for="domain">Domain</label>
                                                        <input type="text" id="domain" name="domain" placeholder="Domain" maxlength="50" :disabled="isReadOnly" :value="dto.domain" @change="dto.domain = $event.target.value" ref="domain" :pattern="filePathRegex" optional="">

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label for="username">Username</label>
                                            <input type="text" id="username" name="username" placeholder="Username" maxlength="50" :disabled="isReadOnly" style="margin-top: 0!important;" :pattern="usernameRegex" :value="dto.username" @change="dto.username = $event.target.value" ref="username" optional="">

                                        </div>

                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label for="password">Password</label>
                                            <input type="password" id="password" name="password" maxlength="50" :disabled="isReadOnly" :value="dto.password" @change="dto.password = $event.target.value" ref="password" placeholder="Password" optional="">

                                        </div>

                                        

                                    </div>

                                </div>

                            </div>

                        </div>
                        <div class="mu-d-flex mu-justify-content-end mu-mt-05" >
                                            <div class="mcc-button-group mcc-button-group--spaced mcc-button-group-flex-wrap">
                                            <router-link v-if="newConnection" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId+'/apis/'+apiId">
                                                <button class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn" title="Cancel" type="button">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                </button>
                                            </router-link>
                                            <button class="mcc-button mcc-button--soft-danger" v-if="!newConnection && !isReadOnly" id="deleteBtn" dialog="deleteFileConnection" title="Delete" type="button" @click="deletefileConnectionMethod()">
                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                            </button>
                                            <button class="mcc-button mcc-button--outline " title="Test connection" id="testConnection" type="button" @click="saveFileConnection()">
                                                <mcc-icon name="connected" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Test connection</span>
                                            </button>
                                            <button class="mcc-button mcc-button--success " v-if="!isReadOnly" title="Save" id="saveConnectionBtn" type="submit" >
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                            </button>
                                        </div>
                                        </div>
                    </div>
                </form>
            </div>
                </div>
            </div>

        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="dataLoaded" color="danger" ref="deleteFileConnectionRef" id="deleteFileConnection">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Delete connection</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteFileConnectionRef.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div v-if="!isDefaultConnection">
                            Are you sure you want to delete this file connection?
                        </div>

                        <div v-if="isDefaultConnection">
                            This connection is marked as active. Continue? </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteFileConnectionRef.close()">No</button>
                            <button type="button" class="mcc-button mcc-button--danger" @click="deleteFileConnection($event)">Yes</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>

</div>
</template>

<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "FileConnectionEdit",
    data() {
        return {
            dto: {
                fileProtocol: "DIRECTORY"
            },
            connectionName: "",
            updateCall: true,
            externalSystemName: "",
            externalSystemAPIName: "",
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            filePathRegex: constantMessages.PATTERNS["filePath"],
            helpDocumentationES: constantMessages.PATTERNS["helpDocumentationES"],
            usernameRegex: constantMessages.PATTERNS["username"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["fileconnection.edit"],
            externalSystemId: this.$route.params.externalSystemId,
            apiId: this.$route.params.apiId,
            connectionId: this.$route.params.connectionId,
            connectionType: [],
            showHelpText: false,
            fetchCall: true,
            newConnection: false,
            dataLoaded: false,
            connectionContainer: {},
            userNamePattern: "",
            isDefaultConnection: false,
            isReadOnly: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"]
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.loadConnectionInfo(false);
    },
    methods: {
        loadConnectionInfo(fetchRef) {
            let self = this;
            self.fetchCall = fetchRef;

            let url =
                "/integrate/external-systems/" +
                self.apiId +
                "/fileconnections/" +
                self.connectionId;
            if (self.connectionId == "new") {
                self.newConnection = true;
                self.helpText = constantMessages.BREADCRUMB_HELP["fileconnection.create"];
                url =
                    "/integrate/external-systems/" +
                    self.apiId +
                    "/fileconnections/api-info";
            }
            ExternalSystemAPI.getConnectionInfo(url)
                .then(result => {
                    if (result == null || result == "") {
                        self.$router.push(self.CONTEXT_PATH + "/integrate/externalsystems");
                        EventBus.$emit("error-notification", {
                            msg: "Error while fetching connection"
                        });
                        return;
                    }
                    self.connectionContainer = result.connectionInfo;
                    self.isReadOnly = result.readOnly;

                    self.externalSystemId = result.connectionInfo.externalSystemId;
                    self.externalSystemName = result.connectionInfo.externalSystemName;
                    self.externalSystemAPIName = result.connectionInfo.externalSystemAPIName;
                    self.dto = result.connectionInfo.fileConnection;
                    if (self.dto.fileProtocol == null) {
                        self.dto.fileProtocol = "DIRECTORY";
                    }
                    self.connectionName = self.dto.name;
                    self.isDefaultConnection = self.connectionContainer.activeConnectionId != null && self.connectionContainer.activeConnectionId == self.connectionId;
                    self.dataLoaded = true;

                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.fileconnection.details"] + " - " + self.connectionName;
                    if (self.newConnection) {
                        pageTitle = constantMessages.PAGEHEADER_TITLE["menu.fileconnection.details"] + " - Create new";
                    }
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(function () {
                    self.fetchCall = true;
                    new SlimSelect({
                        select: '#protocol-selectId',
                    })
                });
        },
        saveFileConnection(e) {
            let self = this;
            let form = $('#connectionForm')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let btnObj = $(document.activeElement);
            if (btnObj[0].id == "testConnection") {
                self.testConnection();
                return;
            }
            self.connectionContainer.fileConnection = self.dto;
            self.updateCall = false;
            ExternalSystemAPI.saveFileConnection(
                self.connectionContainer,
                self.connectionId,
                self.apiId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                            return
                        } 
                        if(response.messages.username == 'error.input.owasp.error' ) {
                            EventBus.$emit('error-notification', {
                                msg: constantMessages.MESSAGES['error.encrypt.invalid.basic']
                            });
                        
                        } else if(response.messages.encrypt == 'error.encrypt.invalid.basic') {
                            EventBus.$emit('error-notification', {
                                msg: constantMessages.MESSAGES['error.encrypt.invalid.basic']
                            });
                        
                        }else {
                            EventBus.$emit('error-notification', {
                                msg: constantMessages.MESSAGES[response.messages[k]]
                            });
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                    if (self.newConnection) {

                        this.$router
                            .push(
                                this.CONTEXT_PATH +
                                "/integrate/externalsystems/" +
                                self.externalSystemId +
                                "/apis/" + self.apiId +
                                "/file/" + response.data.id
                            )
                    } else {
                        self.loadConnectionInfo(true);
                        self.connectionName = response.data.name;
                    }
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
              
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")

            }
            self.dto.name = event.target.value;
        },
        deletefileConnectionMethod() {
            this.$refs.deleteFileConnectionRef.show()
        },
        updateFilePath(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.filePath), constantMessages.MESSAGES["error.externalSystemFileConnection.filepath"])

            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.filePath), constantMessages.MESSAGES["error.externalSystemFileConnection.filepath.length"])
               
            } else {
                self.$refs.filePath.classList.remove("ms-is-invalid")

            }
            self.dto.filePath = event.target.value;
        },
        updateHost(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.host), constantMessages.MESSAGES["error.externalSystemFileConnection.host"])
              
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.host), constantMessages.MESSAGES["host.maxLength.50"])

               
            } else {
                self.$refs.host.classList.remove("ms-is-invalid")

            }
            self.dto.host = event.target.value;
        },
        redirectToFileAPI() {
            let self = this;
            self.$router.push(self.CONTEXT_PATH + '/integrate/externalsystems/' + self.externalSystemId + '/apis/' + self.apiId);
        },
        updateProtocolTytpe(event) {
            if (event.target.value) {
                let self = this;
                self.dto.fileProtocol = event.target.value;
                let protocolType = self.dto.fileProtocol;
                if (protocolType == 'DIRECTORY') {
                    self.dto.port = null
                    self.dto.filePath = "";
                } else if (protocolType == 'SFTP') {
                    self.dto.port = 22;
                    self.dto.directory = "";
                    self.dto.domain = "";
                } else {
                    self.dto.port = 21;
                    self.dto.directory = "";
                    self.dto.domain = "";
                }
                if (self.$refs.connectionForm && self.$refs.connectionForm.update !== undefined) {
                    self.$refs.connectionForm.update();
                }
            }
        },
        deleteFileConnection(e) {
            let self = this;
            self.$refs.deleteFileConnectionRef.close()
            let endPoint = "";
            if (self.isDefaultConnection) {
                endPoint = "/delete-ref";
            }
            self.updateCall = false;
            ExternalSystemAPI.deleteFileConnection(
                self.connectionId,
                self.apiId, endPoint
            ).then(response => {
                self.updateCall = true;
                EventBus.$emit("success-notification", {
                    msg: constantMessages.MESSAGES[response.message]
                });
                this.$router
                    .push(
                        this.CONTEXT_PATH +
                        "/integrate/externalsystems/" +
                        self.externalSystemId +
                        "/apis/" + self.apiId
                    )

            });
        },
        testConnection() {
            let self = this;
            self.updateCall = false;
            ExternalSystemAPI.testFileConnection(
                self.connectionContainer,
                self.connectionId,
                self.apiId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    EventBus.$emit('error-notification', {
                        "msg": constantMessages.MESSAGES[response.message]
                    });
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                }
            });
        },
        exportFiles() {
            ImportExportAPI.exportFiles('FILECONNECTION', this.connectionId);
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        }
    }
};
</script>
